<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('Cargadores')"
      icono="mdi-ev-station"
      tabla="car"
      :campos="['id_car-', 'id_ins', 'numcarins', 'des', 'cod', 'dis', 'id_estcar', 'desest', 'fechorultest-', 'coderr-', 'deserr-', 'traact-', 'inicar-', 'fincar-', 'kwhcar', 'coscar', 'id_apicar-']"
      busqueda-rapida
      :titulo-crud="$t ('cargador')"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gescar");
    }
  },
};
</script>

<style>
</style>